import { Routes, RouterModule } from '@angular/router';
import { TabRequestsComponent } from './tab-requests.component';

const TabRequestsRoutes: Routes = [
  {
    path: '',
    component: TabRequestsComponent,
  },
];

export const MAIN_TABREQUESTS = RouterModule.forChild(TabRequestsRoutes);
